"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCancelSubscriptionProductWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var CustomerCancelSubscriptionProductWidget = /** @class */ (function (_super) {
    __extends(CustomerCancelSubscriptionProductWidget, _super);
    function CustomerCancelSubscriptionProductWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            products: _this.props.interaction.uistate.productsForCancellation ? _this.props.interaction.uistate.productsForCancellation : []
        };
        return _this;
    }
    CustomerCancelSubscriptionProductWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group checkbox-margin-top-20", children: [(0, jsx_runtime_1.jsx)("label", { children: "What Flow subscription do you want to cancel?" }), (0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": "What Flow subscription do you want to cancel?", children: this.renderProducts() }), this.state.products.includes(services_1.PRODUCT_MOTOR) && this.props.interaction.vehicles &&
                            (0, jsx_runtime_1.jsxs)("div", { className: "pt-2", children: [(0, jsx_runtime_1.jsx)("img", { className: "cancel-subscription-attention-icon d-block", src: "/img/attention_icon_blue.png", alt: "warning" }), (0, jsx_runtime_1.jsxs)("p", { children: ["You have ", this.props.interaction.vehicles.length, " cars on your car subscription. To remove or replace them go to Car(s) area in your account space"] })] })] }) }) }));
    };
    CustomerCancelSubscriptionProductWidget.prototype.renderProducts = function () {
        var _this = this;
        var products = [
            { key: 1, value: services_1.PRODUCT_MOTOR },
            { key: 2, value: services_1.PRODUCT_RENTERS }
        ];
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: products.map(function (product) {
                return (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3 mt-1", onClick: function (e) { return _this.handleOnClickEvent(e, product.value); }, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(_this.isChecked(product.value)), type: "checkbox", "aria-label": _this.getSetting("ariaLabel", ""), onChange: function (e) { return _this.handleOnClickEvent(e, product.value); }, value: product.value, onDoubleClick: _this.executeNativeEvent, name: product.value, id: _this.props.question.name + product.value, checked: _this.isChecked(product.value) }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: _this.props.question.name + product.value, "aria-label": product.value, children: (0, jsx_runtime_1.jsx)("div", { id: product.value, className: "checkbox-big" }) })] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0 ".concat(_this.isChecked(product.value)), children: product.key === 1 ? "Car" : "Renters" })] }, product.key);
            }) }));
    };
    CustomerCancelSubscriptionProductWidget.prototype.handleOnClickEvent = function (event, product) {
        var _this = this;
        event.preventDefault();
        var products = this.state.products;
        var changed = false;
        if (products.length > 0) {
            products.forEach(function (productName) {
                if (productName === product) {
                    _this.deleteProduct(product);
                    changed = true;
                }
            });
        }
        if (!changed && !this.state.products.includes(product)) {
            this.addProduct(product);
        }
    };
    CustomerCancelSubscriptionProductWidget.prototype.isChecked = function (product) {
        var products = this.state.products;
        var result = false;
        products.forEach(function (productName) {
            if (productName === product) {
                result = true;
            }
        });
        return result;
    };
    CustomerCancelSubscriptionProductWidget.prototype.deleteProduct = function (product) {
        var products = this.state.products;
        var productIndex = products.findIndex(function (id) { return id.localeCompare(product) === 0; });
        if (productIndex > -1) {
            products.splice(productIndex, 1);
        }
        this.setState({
            products: products
        });
        this.props.onStateChange("uistate.productsForCancellation", this.state.products);
        this.executeEvent("change");
    };
    CustomerCancelSubscriptionProductWidget.prototype.addProduct = function (product) {
        var products = this.state.products;
        products.push(product);
        this.setState({
            products: products
        });
        this.props.onStateChange("uistate.productsForCancellation", this.state.products);
        this.executeEvent("change");
    };
    return CustomerCancelSubscriptionProductWidget;
}(plugin_journey_1.WidgetBase));
exports.CustomerCancelSubscriptionProductWidget = CustomerCancelSubscriptionProductWidget;
//# sourceMappingURL=CustomerCancelSubscriptionProductWidget.js.map